import OrganizationsIndex from "./OrganizationsIndex";
export default OrganizationsIndex;
